
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.593 8.66a.9.9 0 11-.092-1.798c2.758-.14 5.574.954 7.649 2.502.975.727 1.787 1.553 2.356 2.395.569.842.894 1.7.894 2.49 0 .941-.464 1.982-1.243 2.967a.9.9 0 11-1.412-1.116c.41-.519.855-1.168.855-1.85 0-.313-.139-.822-.586-1.483-.436-.646-1.097-1.331-1.94-1.96-1.836-1.37-4.17-2.265-6.481-2.147zM6.85 19.136C8.8 20.59 11.4 21.65 14 21.65c1.967 0 3.93-.607 5.604-1.523l1.26 1.259a.9.9 0 101.272-1.273l-13.5-13.5a.9.9 0 00-1.273 1.273l.684.684c-.419.246-.82.512-1.197.794-.975.727-1.788 1.553-2.357 2.395-.569.842-.893 1.7-.893 2.49 0 .791.324 1.649.893 2.491.57.842 1.382 1.668 2.357 2.396zm5.55-4.886a1.6 1.6 0 002.586 1.26l-2.246-2.247c-.214.272-.34.615-.34.987zm1.6 3.4a3.4 3.4 0 01-2.537-5.664L9.369 9.892c-.513.274-.997.582-1.443.914-.844.63-1.505 1.315-1.941 1.96-.447.662-.585 1.171-.585 1.484 0 .312.138.821.585 1.482.436.646 1.097 1.331 1.941 1.96C9.63 18.965 11.862 19.85 14 19.85c1.439 0 2.925-.402 4.269-1.059l-2.005-2.005A3.39 3.39 0 0114 17.65z","fill":"currentColor"}})])
          )
        }
      }
    